<template>
    <div class="success-container text-center py-5">
        <div class="mb-4">
            <div class="success-icon-wrapper shadow-lg mb-4">
                <i class="ri-checkbox-circle-fill text-success display-2"></i>
            </div>
            <div v-if="confirmationMessage" class="px-md-5 mb-4" v-html="confirmationMessage"></div>
            <div v-else>
                <h2 class="font-weight-bold text-dark mb-3">{{ $t('application_success_title') }}</h2>
                <p class="text-muted font-size-16 mb-4 px-md-5">
                    {{ $t('application_success_description') }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import ConstantService from "@/services/ConstantService";
import qs from "qs";

export default {
    name: "CompletedTab",
    data() {
        return {
            confirmationMessage: null
        }
    },
    mounted() {
        this.getConfirmationMessage()
    },
    methods: {
        getConfirmationMessage() {
            const config = {
                params: {
                    'key': 'bisep_application.confirmation_message'
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            }
            ConstantService.getValue(config).then(response => {
                this.confirmationMessage = response.data.data
            }).catch(e => {
                this.showErrors(e, null)
            })
        }
    }
}
</script>

<style scoped>
.success-container {
    background: linear-gradient(180deg, #f0fff4 0%, #ffffff 100%);
    border-radius: 20px;
    padding: 40px 20px;
    border: 1px solid #e6ffed;
}

.success-icon-wrapper {
    width: 100px;
    height: 100px;
    background: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    box-shadow: 0 10px 25px rgba(40, 167, 69, 0.15);
    animation: scaleIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes scaleIn {
    from {
        transform: scale(0);
        opacity: 0;
    }
    to {
        transform: scale(1);
        opacity: 1;
    }
}

.font-size-16 { font-size: 16px; }
</style>
